import * as LockScroll from './LockScroll.js';
import { resetForm } from './Form.js';
import { setNeedVacancy } from './PageVacancy.js';

let $popupWraps = $('.js-popup-wrap');

$popupWraps.find('input').prop('disabled', true);

$('.js-popup-form').on('click', function (e) {
    let _popupName = $(this).data('popup-wrapper');

    setNeedVacancy($(this).data('vacancy'));

    LockScroll.lock();
    App.H.addClass('_popup-opened');
    $popupWraps.filter(`[data-popup-wrapper="${_popupName}"]`).addClass('_open');

    $popupWraps.filter(`[data-popup-wrapper="${_popupName}"]`).find('input').prop('disabled', false);
    e.preventDefault();
});


$('.js-close-popup-form').on('click', function (e) {
    let $currPopup = $(this).closest('.js-popup-wrap._open');

    $currPopup.removeClass('_open');
    resetForm($currPopup.find('.js-form'));
    LockScroll.unlock();
    App.H.removeClass('_popup-opened');

    $currPopup.find('input').prop('disabled', true);

    e.preventDefault();
});

App.D.on('mouseup', function(e) {
    let $openedPopup = $('.js-popup-wrap._open');

    if (!$openedPopup.is(e.target) && $openedPopup.has(e.target).length === 0) {
        $openedPopup.find('.js-close-popup-form').trigger('click');
    }
});


// WEBPACK FOOTER //
// ./_src/js/modules/PopupForms.js